<div class="modal-head-title">
    <div (click)="activeModal.close()" class="close-modal pr-0">
        <app-icon [type]="'ThinCross'"></app-icon>
    </div>
    <h3 class="modal-title modal-title-text">{{ title }}</h3>
</div>
